import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Menu from '../Menu';
import PageTitle from '../PageTitle';
import { active } from './styles.css';

const messages = defineMessages({
  viewConnections: {
    id: 'amplus.view.connections',
    defaultMessage: 'Connections',
  },
  viewFilters: {
    id: 'amplus.view.filters',
    defaultMessage: 'Filters',
  },
});

const AMPlusFrame = (props) => (
  <div styleName="container">
    <PageTitle title="Active Match" subTitle="View Connections" category="Connection" />
    <nav aria-label="ActiveMatch Menu">
      <Menu stackable as="ul" pointing secondary size="huge" styleName="menu">
        <Menu.Item as="li" link styleName="menu-item">
          <Link to="/am-plus/view-connections" styleName="menu-link" activeClassName={active}>
            <FormattedMessage {...messages.viewConnections} />
          </Link>
        </Menu.Item>
      </Menu>
    </nav>
    <main aria-labelledby="pageTitle" styleName="content" id="content">
      {props.children}
    </main>
  </div>
);

AMPlusFrame.propTypes = {
  children: PropTypes.node,
};

export default injectIntl(AMPlusFrame);
